import React, { Component } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider1 from "../../assests/images/slider1.jpeg";
import Slider2 from "../../assests/images/slider2.jpg";
import Slider3 from "../../assests/images/slider3.png";

class HomeSlider extends Component {

    render() {

        const settings = {
            dots: true,
            infinite: true,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: false,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 0
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 0
                    }
                }
            ]
        };

        return (
            <div className="home-slider">
                <Slider {...settings}>

                    <div>
                        <img
                            className="slider-img"
                            src={Slider1}
                            alt="Prime Luxury Passenger Transport"
                        />
                    </div>

                    <div>
                        <img
                            className="slider-img"
                            src={Slider2}
                            alt="Prime Luxury Passenger Transport"
                        />
                    </div>

                    <div>
                        <img
                            className="slider-img"
                            src={Slider3}
                            alt="Prime Luxury Passenger Transport"
                        />
                    </div>

                </Slider>
            </div>
        );
    }
}

export default HomeSlider;